import { render } from "./KnowledgeHub.vue?vue&type=template&id=23a52567"
import script from "./KnowledgeHub.vue?vue&type=script&lang=js"
export * from "./KnowledgeHub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__